// extracted by mini-css-extract-plugin
export default {"expandedTable":"styles_expandedTable__O19dQ"};